import { useUnmount } from 'ahooks';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { isRegularOrg } from 'domains/orgDomain';
import { useOrg } from 'hooks/useOrg';
import { useEffect } from 'react';
import EqptAdminTable from './EqptAdminTable';
import EqptBaseSelect from './EqptBaseSelect';
import EqptItemForm from './EqptItemForm';

const EqptAdmin = () => {
  const org = useOrg();
  const regular = org && isRegularOrg(org);
  const curItem = useAppSelector((state) => state.eqpt.item);
  const dispatch = useAppDispatch();

  useUnmount(() => {
    dispatch.eqpt.reset();
    dispatch.app.setState({
      filterForceHidden: false,
    });
  });

  useEffect(() => {
    if (curItem) {
      dispatch.app.setState({
        filterForceHidden: true,
      });
    } else {
      dispatch.app.setState({
        filterForceHidden: false,
      });
    }
  }, [curItem, dispatch.app]);

  return (
    <>
      {curItem && <EqptItemForm />}
      {regular && <EqptBaseSelect />}
      <EqptAdminTable />
    </>
  );
};

export default EqptAdmin;
